import { Injectable } from '@angular/core';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';
import { LocalStorageService } from '@sb-tools/typescript/services/local-storage.service';
import { CommonDataFaqService } from '@shared/services/common-data-faq.service';
import { Params } from '@angular/router';
import { AVAILABLE_URL_LANGUAGES } from '@shared/constants/available-url-languages';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    defaultLanguage: LocalizationLanguage;
    selectedLanguage: LocalizationLanguage;

    readonly LocalizationLanguages = [
        LocalizationLanguage.norwegian,
        LocalizationLanguage.english,
        LocalizationLanguage.swedish,
        LocalizationLanguage.danish,
        LocalizationLanguage.finnish,
    ];
    private readonly languageKey = 'SbLanguage';

    constructor(
        private localStorageService: LocalStorageService,
        public commonDataFaqService: CommonDataFaqService,
    ) {}

    getLanguageName(language: LocalizationLanguage): string {
        return AVAILABLE_URL_LANGUAGES.find((urlLanguage) => {
            return urlLanguage.language === language;
        }).urlParam;
    }

    getLanguageByName(language: string): LocalizationLanguage {
        return AVAILABLE_URL_LANGUAGES.find((urlLanguage) => {
            return urlLanguage.urlParam === language;
        })?.language;
    }

    getSavedLanguage(): LocalizationLanguage {
        return Number(this.localStorageService.getItem(this.languageKey));
    }

    initLanguage(): void {
        this.defaultLanguage = this.commonDataFaqService.faqSettings.languages.find((language) => {
            return language.isDefault;
        }).language;
    }

    setLanguage(language: LocalizationLanguage): void {
        this.selectedLanguage = language;
        this.localStorageService.setItem(this.languageKey, language.toString());
    }

    setLanguageAndReload(language: LocalizationLanguage, urlParams: Params): void {
        if (language === this.selectedLanguage) {
            return;
        }
        const segmentIndex = urlParams.language ? 3 : 2;

        const urlParts = window.location.pathname.split('/');
        urlParts.splice(segmentIndex, 1, this.getLanguageName(language));
        window.location.pathname = urlParts.join('/');
    }
}
